import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Container, Grid, Typography, Box } from '@mui/material';
import './dashboard.scss';

export default function DeviceDashboard() {
  const navigate = useNavigate();
  return (
    <Container sx={{ p: 4, minHeight: '100vh' }}>
      <Button
        sx={{
          mb: 2,
          color: 'primary.main',
          '&:hover': { bgcolor: 'grey.200' },
        }}
        variant="text"
        onClick={() => {
          navigate('/help-center');
        }}
      >
        <span>← Back</span>
      </Button>

      <div className="help__center__container" lang="en">
        <Box sx={{ mb: 4 }}>
          <Grid container spacing={2}>
            <Grid item>
              <Button variant="outlined" href="/help-center/dashboard">
                Overview
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/building">
                Building
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" href="/help-center/devices">
                Devices
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/settings">
                Settings
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/map">
                Map
              </Button>
            </Grid>
          </Grid>
        </Box>
        <div className="help__center__hero">
          <h1>Devices Overview Guide</h1>
        </div>
        <div className="content__box">
          <img src="/helpcenter/inspect.png" alt="Inspect Option" />
          <p>
            <strong>Inspect:</strong> The <em>Inspect</em> option is available
            from the three-dot menu on a device card. Selecting this allows you
            to drill down into a specific device&#39;s historical data.
          </p>
          <ul>
            <li>
              Export the data as <strong>Excel</strong> or <strong>CSV</strong>
            </li>
            <li>
              Add the chart to <strong>Analytics</strong> or{' '}
              <strong>Overview</strong>
            </li>
            <li>Inspect trends over time using a line chart</li>
          </ul>
          <p>
            This feature helps users isolate temperature behavior over a
            selected period and take further action based on insights.
          </p>
        </div>

        <div className="content__box">
          <img src="/helpcenter/inspectDevice.png" alt="Inspect Device View" />
          <p>
            <strong>Inspect Device:</strong> This view opens a detailed chart of
            the selected device&#39;s average temperature over time.
          </p>
          <ul>
            <li>
              Time Range Selector: Choose custom start and end timestamps to
              refine the visible data window.
            </li>
            <li>
              Detail Level Dropdown: Select data granularity (5 min, 15 min, 60
              min, or daily).
            </li>
          </ul>
          <p>
            This detailed view allows for in-depth analysis of temperature data
            to identify trends, anomalies, or performance issues.
          </p>
        </div>
      </div>
    </Container>
  );
}
